import OverviewCard from 'pages/app/overview/overview-cards/OverviewCard.tsx'
import { routes } from 'types/routes.ts'
import { useGetProducerByIdQuery } from 'store/queries/bolt-api/producers'
import { ProducerOverviewCardProps } from './types.ts'
import { useTranslation } from 'react-i18next'
import { useStoreSelector } from 'hooks/store.ts'
import { useGetLanguage } from 'hooks/use-get-language'
import LoadingSkeleton from 'components/loading-skeleton/LoadingSkeleton.tsx'
import { selectIsProducerAccount } from 'store/contact/slice.ts'
import parse from 'html-react-parser'

const ProducerOverviewCard = ({ producerId }: ProducerOverviewCardProps) => {
  // REDUX STORE
  const isProducer = useStoreSelector(selectIsProducerAccount)

  // Redux Queries
  const { data, isLoading } = useGetProducerByIdQuery({ producerIdOrSlug: producerId ?? '' }, { skip: !producerId })

  // i18n
  const { t } = useTranslation('overview')
  const lowerCaseLanguage = useGetLanguage('lowercase')

  // Constants
  const translationKey = isProducer ? 'producer' : 'consumer'

  if (!producerId || (isProducer && !data?.producer?.enabled)) return null

  return isLoading || data?.producer ? (
    <OverviewCard
      isLoading={isLoading}
      button={{
        label: t(($) => $.producer.button[translationKey]),
        href: routes.PRODUCER
      }}
      image={
        isLoading
          ? { loading: isLoading }
          : data?.producer
            ? {
                src: `${data?.producer?.images?.profile?.url}`,
                alt: `Producer: ${data?.producer?.name?.[lowerCaseLanguage]}`
              }
            : undefined
      }
    >
      {isLoading ? (
        <>
          <LoadingSkeleton.Title />
          <LoadingSkeleton.Paragraph lines={2} />
        </>
      ) : (
        <>
          <OverviewCard.Title>
            {parse(
              t(($) => $.producer.title[translationKey], {
                producer: data?.producer?.name?.[lowerCaseLanguage]
              })
            )}
          </OverviewCard.Title>
          <p>{t(($) => $.producer.description[translationKey])}</p>
        </>
      )}
    </OverviewCard>
  ) : null
}

export default ProducerOverviewCard
